
import {computed, defineComponent, toRef} from 'vue';
import useFormValidation from '../../../composables/useFormValidation';
import Spinner from '@ohrm/oxd/core/components/Loader/Spinner.vue';

export default defineComponent({
  name: 'oxd-form',

  components: {
    'oxd-loading-spinner': Spinner,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, context) {
    const isLoading = toRef(props, 'loading');
    const {validate, reset, errorbag, fieldset} = useFormValidation(isLoading);

    const isProcessing = computed(() => {
      return fieldset.value.reduce((acc, field) => {
        return acc || field.processing;
      }, false);
    });

    const isFromInvalid = computed(() => {
      return errorbag.value.length > 0;
    });

    const isFormBusy = computed(() => {
      return props.loading || isProcessing.value;
    });

    const onSubmit = (e: Event) => {
      if (isFormBusy.value) return;
      setTimeout(async () => {
        await validate();
        if (!isFromInvalid.value) {
          context.emit('submitValid', e);
        } else {
          context.emit('submitInvalid', e);
        }
      }, 0);
    };

    return {
      onSubmit,
      fieldset,
      errorbag,
      validate,
      isProcessing,
      isFromInvalid,
      isFormBusy,
      onReset: reset,
    };
  },
});
